import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BranchofficeService } from '../api/admin/branchoffice.service';
import { LoginService } from '../api/auth/login.service';
import { environment } from '../environment';
declare var $: any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit{
  nameApp: string = 'Nombre App';
  user: any;
  branchofficeSlug = '';

  constructor(private authService: LoginService, private router: Router) {
    this.nameApp = environment.name_app;
    this.user = this.authService.getUser();
    // this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    console.log("carga");
  }

  logout() {
    this.showloader();
    this.authService.logout().subscribe(
      data => {
        this.authService.removeToken();
        this.authService.removeUserData();
        this.authService.removeUserPermissions();
        this.hideloader();
        this.router.navigate(["/login"]);
      },
      error => {
        console.log(error);
      }
    )
  }

  showloader() {
    (<HTMLInputElement>document.getElementById('loading')).style.display =
      'block';
  }

  hideloader() {
    (<HTMLInputElement>document.getElementById('loading')).style.display =
      'none';
  }
}

